import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { NavigationFailureType } from 'vue-router';
import draggable from 'vuedraggable';
import apolloProvider from '~/nasa_ui/apollo.config';
import { initializeCurrentUser } from '~/nasa_ui/mixins/CurrentUserMixin';
import { addCtxParam, checkSetActiveSupportContextViaQuerystring, checkUserForPermissionRequirements, checkUserForSupportContexts, checkUserRoleRequirements, localCheckForRunningAsSystem, logRouteChanges, refreshCurrentUser, updateImportantThings } from '~/nasa_ui/router/utils';
import { store } from '~/nasa_ui/store';
import { EsocApplicationDisplay } from '~/nasa_ui/types';
import { stripHtmlFromString } from '~/nasa_ui/utils';
import { storeAuthRedirect } from '~/nasa_ui/utils/authRedirect';
import silenceNavigationalErrors from '~/nasa_ui/utils/silenceNavigationalErrors';
import { AxiosPlugin, ChartsPlugin, DatePlugin, DisplayPlugin, HumanizePlugin, LodashPlugin, SafeHtml, Vuetify, VuetifyTheme, WebPlugin } from '~/nasa_ui/vue_plugins';
import { default as installWebComponents } from '~/web_components/install_components';
Vue.config.productionTip = false;
Vue.config.ignoredElements = [/c-*/];
Vue.component('draggable', draggable);
// Registration of plugins
Vue.use(AxiosPlugin);
Vue.use(ChartsPlugin);
Vue.use(DatePlugin);
Vue.use(DisplayPlugin);
Vue.use(HumanizePlugin);
Vue.use(LodashPlugin);
Vue.use(VueApollo);
Vue.use(SafeHtml);
Vue.use(Vuetify, VuetifyTheme);
Vue.use(WebPlugin);
export async function bootstrapMe(options) {
    const { App, router, cosmicSystem, cosmicEnvironment, cosmicApplicationConfiguration, cosmicApplication } = options;
    Vue.use({
        install() {
            Object.defineProperties(Vue.prototype, {
                $cosmicApplication: { value: cosmicApplication },
                $cosmicSystem: { value: cosmicSystem },
                $cosmicEnvironment: { value: cosmicEnvironment },
                $cosmicApplicationConfiguration: { value: cosmicApplicationConfiguration },
                $validUserSupportContexts: { value: cosmicApplicationConfiguration.userSupportContexts }
            });
        }
    });
    storeAuthRedirect();
    const vueRouter = router.router;
    // Router middlewares
    checkSetActiveSupportContextViaQuerystring(vueRouter);
    refreshCurrentUser(vueRouter);
    localCheckForRunningAsSystem(vueRouter);
    updateImportantThings(vueRouter);
    checkUserForSupportContexts(vueRouter);
    checkUserRoleRequirements(vueRouter);
    checkUserForPermissionRequirements(vueRouter);
    addCtxParam(vueRouter);
    logRouteChanges(vueRouter);
    silenceNavigationalErrors([NavigationFailureType.duplicated, NavigationFailureType.cancelled]);
    // install base web components + allow extra components
    const baseComponents = [
        'Button',
        'ButtonIcon',
        'Callout',
        'Card',
        'Checkbox',
        'IconFa',
        'IconFaStacked',
        'IconNasaMeatball',
        'IconNasaWorm',
        'IconNotCosmic',
        'ListGroup',
        'ListGroupItem',
        'Menu',
        'MenuItem',
        'Modal',
        'Number',
        'Para',
        'Popover',
        'Progress',
        'Radio',
        'RadioGroup',
        'Select',
        'Spinner',
        'Tab',
        'TabGroup',
        'TabPanel',
        'Text',
        'Toaster'
    ];
    Promise.all(installWebComponents(baseComponents))
        .then(initializeCurrentUser)
        .then((currentUser) => {
        store.currentUser = currentUser;
        const vm = new Vue({
            apolloProvider,
            router: vueRouter,
            render: (h) => h(App),
            watch: {
                $route: {
                    immediate: true,
                    handler(to) {
                        const name = stripHtmlFromString(to.meta?.name || '');
                        if (name) {
                            document.title = name;
                        }
                        else {
                            document.title = `${EsocApplicationDisplay.get(cosmicApplication)} - ${cosmicEnvironment}`;
                        }
                    }
                }
            }
        }).$mount('#app');
        vm.$message('application_version', options.applicationVersion);
        return vm;
    });
}
